import {
  configureStore,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';

export interface GlobalState {
  activeMenu: string;
  unreadCount: number;
  lastUpdated: number | null;
  projectContentId:string | null;
}

const initialState: GlobalState = {
  activeMenu: 'dashboard',
  unreadCount: 0,
  lastUpdated: null,
  projectContentId: null,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setActiveMenu(state, action: PayloadAction<string>) {
      state.activeMenu = action.payload;
      state.lastUpdated = Date.now();
    },
    setUnreadCount(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
      state.lastUpdated = Date.now();
    },
    setProjectContentId(state, action: PayloadAction<string>) { 
      state.projectContentId = action.payload; 
    },
    increaseUnread(state, action: PayloadAction<number | undefined>) {
      state.unreadCount += action.payload ?? 1;
      state.lastUpdated = Date.now();
    },
    resetGlobal: () => initialState,
    
  },
});

export const { setActiveMenu, setUnreadCount, increaseUnread, resetGlobal,setProjectContentId } =
  globalSlice.actions;

export const store = configureStore({
  reducer: {
    global: globalSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const selectActiveMenu = (state: RootState) => state.global.activeMenu;
export const selectUnreadCount = (state: RootState) => state.global.unreadCount;
export const selectLastUpdated = (state: RootState) => state.global.lastUpdated;
export const selectProjectContentId = (state: RootState) => state.global.projectContentId;
